const emptyRow = (id, name) => ({
    surveyor_id: id,
    surveyor_name: name || String(id),
    valid: 0,
    invalid: 0,
    total: 0,
});

const checkerFromLog = (row) => {
    const log = Array.isArray(row?.qalog) ? row.qalog : [];
    const last = log[log.length - 1];
    const user = last?.user;
    if (!user?.id) return null;
    return { id: user.id, name: user.name };
};

export const rowsFromQaLog = (responses = []) => {
    const groups = new Map();

    responses.forEach((row) => {
        const checker = checkerFromLog(row);
        if (!checker) return;

        if (!groups.has(checker.id)) {
            groups.set(checker.id, emptyRow(checker.id, checker.name));
        }

        const bucket = groups.get(checker.id);
        if (row?.qa_status === "valid") bucket.valid += 1;
        if (row?.qa_status === "invalid") bucket.invalid += 1;
        bucket.total += 1;
    });

    return Array.from(groups.values());
};
